export default __webpack_public_path__ + "static/media/Avax.010f2a10.png";